module.exports = __webpack_public_path__ + "img/size12.007fb24c.png";